<template>
 <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Inter&display=swap" rel="stylesheet">
 
<div class=" text-site-text">
  <router-view v-slot="{ Component }">
    <transition>
      <component :is="Component" />
    </transition>
    </router-view>

</div>

</template> 

<script>


export default {
  name: 'App',
  

}
</script>

<style setup>
 @tailwind base;
@tailwind components;
@tailwind utilities;



body{
  @apply bg-site-background;
  
}

p {
  font-size: 0.9em;
  line-height: 1.5;
}

h1 {
  margin-top: 0;
}
    hr {
  display: block;
  height: 1px;
  margin: 1.5em 0;
  border: 0;
  background-color: #000000;
}

.formkit-form {
  display: flex;
  flex-direction: column;
  padding: 1.5em;
  border-radius: 1em;
  margin: 0 auto 1em auto;
  @apply bg-site-primary;
}

#app {


  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
 
 
}



</style>
